import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import BadgeWithIcon from 'core/elements/badge/BadgeWithIcon'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'

interface PopoverHeaderProps {
  isExpanded: boolean
  onToggleExpand: () => void
  onClose: () => void
  bundleCount: number
  hasActiveBundles: boolean
}

const PopoverHeader: React.FC<PopoverHeaderProps> = ({
  isExpanded,
  onToggleExpand,
  onClose,
  bundleCount,
  hasActiveBundles,
}) => {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <Text variant="body1" className={classes.headerTitle}>
          Generating Support Bundles ({bundleCount})
        </Text>
      </div>
      <div className={classes.headerRight}>
        {hasActiveBundles && (
          <BadgeWithIcon
            text="Ongoing"
            variant="primary"
            icon="arrows-rotate"
            data-testid="ongoing-badge"
            spin={true}
          />
        )}

        <FontAwesomeIcon
          size="md"
          solid={true}
          onClick={onToggleExpand}
          data-testid="toggle-expand-button"
        >
          {isExpanded ? 'chevron-up' : 'chevron-down'}
        </FontAwesomeIcon>

        {!hasActiveBundles && (
          <FontAwesomeIcon
            size="md"
            solid={true}
            onClick={onClose}
            data-testid="close-all-bundles-button"
          >
            close
          </FontAwesomeIcon>
        )}
      </div>
    </div>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
    backgroundColor: theme.palette.grey[100],
  },
  headerTitle: {
    fontWeight: 600,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}))

export default PopoverHeader
